import { requestScrollToTop } from '@/app/components/ScrollToTop/ScrollToTop'
import type { ComponentProps } from 'preact'
import { Link as WouterLink, useLocation } from 'wouter-preact'

export function Link({ to, ...props }: ComponentProps<typeof WouterLink>) {
  const [location] = useLocation()
  return (
    <WouterLink
      to={to}
      state={{ from: location }}
      {...props}
      onClick={() => {
        requestScrollToTop()
        props.onClick?.()
      }}
    />
  )
}
